/**
 * In-browser preview cap (owner 2026-10-20). A full decode costs about
 * 4 bytes per pixel, so 120 MP is ~480 MB: past that a phone tab (iPhone
 * Safari above all) gets killed and the customer loses every photo picked.
 * Computers cope, so they get the larger `maxDecodeMegapixelsDesktop`
 * (a 139 MP A0 file was refused on 19 Oct). Both values live in pricing.json.
 */
import { seedPricing, type PricingData } from '@rpl/pricing';

type Limits = Pick<PricingData['limits'], 'maxDecodeMegapixels' | 'maxDecodeMegapixelsDesktop'>;

export function isPhoneOrTablet(
  nav: { userAgent: string; maxTouchPoints?: number } | undefined = typeof navigator !== 'undefined'
    ? navigator
    : undefined,
): boolean {
  if (!nav) return false;
  const ua = nav.userAgent || '';
  if (/iPhone|iPad|iPod|Android|Mobile|Silk|Kindle/i.test(ua)) return true;
  // iPadOS reports itself as a Mac; a touch screen gives it away.
  return /Macintosh/.test(ua) && (nav.maxTouchPoints ?? 0) > 1;
}

export function decodeMegapixelCap(limits: Limits, phoneOrTablet = isPhoneOrTablet()): number {
  if (phoneOrTablet) return limits.maxDecodeMegapixels;
  return (
    limits.maxDecodeMegapixelsDesktop ??
    seedPricing.limits.maxDecodeMegapixelsDesktop ??
    limits.maxDecodeMegapixels
  );
}
